import type { Goal } from "instantdb/types";

export const MOVEMENT_GOALS: Partial<Goal>[] = [
  {
    id: "active-commuting",
    title: "Active commuting",
    description: "Incorporate walking or biking into your daily commute",
    symbol: "🚶",
  },
  {
    id: "regular-movement-breaks",
    title: "Regular movement breaks",
    description: "Take short movement breaks throughout your day",
    symbol: "⏱️",
  },
  {
    id: "daily-stretch-routine",
    title: "Daily stretch routine",
    description: "Incorporate stretching into your daily routine",
    symbol: "🧘",
  },
];
